<template>
  <div class="d-flex flex-column m-0 p-0 border border-primary rounded-lg" style="height: 100vh">
    <div class="p-2 border flex-grow-1 overflow-auto">

      <div class="p-2 d-flex justify-content-between">
          <div>
            <p class="h6 font-weight-bold m-0 p-0">
              {{ $t('lang.label.notes_title')}}
            </p>
            <small class="text-muted">
              {{ $t('lang.label.notes_title_response')}}
            </small>
          </div>

          <!-- Button status -->
          <div v-if="listOfNotes.length > 0 && hasPermissions('superAdmin')">

            <select v-model="targetNoteStatus" class="form-control" @change="changeTargetNoteStatus()">
              <option v-for="(status, i) in noteStatuses" :key="i" :value="i">
                {{ status.label }}
              </option>              
            </select>
          </div>
        </div>

        <!-- Renderizacion de lista de notas -->
        <div>
          <ul v-for="(note, i) in listOfNotes" :key="i">
            <li
            class="px-3 py-2 mx-2 my-3 border rounded-lg"
            :class="[
              note.role_id == 1 ? 'bg-primary text-white border-primary' : 'bg-light border-secondary',
              note.user_id == currentUserId ? 'text-right' : 'text-left']"
            >

              <div class="d-flex flex-column justify-content-between">
                <div class="row px-2 justify-content-between">
                  <div>
                    <button class="mr-1 px-2 btn btn-primary btn-sm btn-outline-primary btn-outline-light bg-white text-primary font-weight rounded-pill"
                      v-if="note.role_id == 1  && (note.user_id == currentUserId)"
                      @click="setNoteToEdit(note.id)">
                      <span v-if="!editNoteId || (editNoteId && editNoteId != note.id)">
                        <b>Modify</b>
                      </span>
                      <span class="text-danger" v-if="editNoteId && editNoteId == note.id">
                        <b>Modify...</b>
                      </span>
                    </button>
                    <i v-if="lastNoteModifyId && lastNoteModifyId == note.id"
                          class="fa fa-check fa-1x ml-1 text-success"
                    >
                    </i>
                  </div>
                <div class="py-1">
                  <img
                    :src="(note.avatar) ? note.avatar : require('@/assets/images/user.png')"
                    class="rounded"
                    width="23px"
                  />
                  <small class="ml-2">
                  {{ note.name }} {{ note.lastname }}
                  </small>
                  <small>
                    - {{ note.created }}
                  </small>
                </div>
                </div>
              </div>
              <div>
                <small>{{note.message}}</small>
              </div>

            </li>
          </ul>
        </div>
      </div>

      <!-- Text Area, Agregar nueva nota -->
      <div class="pr-4 pl-3 pb-3 text-right">
          <div class="form-group">
            <textarea
              ref="newNoteTextarea"
              :disabled="savingData"
              class="form-control mt-3"
              :placeholder="$t('lang.label.publish_message')"
              id
              rows="4"
              v-model="message"
            ></textarea>
            </div>

            <!-- Button cancel edit -->
            <button
              :disabled="savingData"
              v-if="editNoteId"
              class="btn btn-danger mx-1"
              @click="setNoteToEdit(null)"
            >
              {{$t('lang.button.cancel')}}
            </button>

            <!-- Button save -->
            <button
              :disabled="savingData || !this.message || isStringEmpty(this.message)"
              class="btn btn-primary themed-button ml-1"
              @click="createTargetNote()"
            >
             {{$t('lang.label.publish')}}
            </button>
      </div>
  </div>

</template>

<script>
import { targetsService } from '@/_services';

export default {
  data() {
    return {
      statusSelected: null,
      noteStatuses: [
        { id: 0, label: 'Closed'},
        { id: 1, label: 'Open L1'},        
        { id: 2, label: 'Open L2'},
      ],
      listOfNotes:[],
      message:"",
      savingData: false,
      editNoteId: null,
      lastNoteModifyId: null,
      targetNoteStatus: 1, //(1 open, 0 close)
    };
  },

  props: {
    targetId: {
      type: String,
      required: true
    },
    currentUserId: {
      type: String,
      required: true
    }
  },

  created() {
    this.getTargetNotes();
  },

  computed: {
    isStringEmpty() {
      return (value) => {
        return value.replace(/\s/g, '').length == 0
      }
    }
  },

  methods: {
    setNoteToEdit(note_id) {
      if(!note_id){
        this.message = ''
        this.editNoteId = null
      } else {
        const note = this.listOfNotes.find( el => el.id == note_id)
        this.message = note.message
        this.editNoteId = note.id
        if (note_id == this.lastNoteModifyId) {
          this.lastNoteModifyId = null
        }
        this.$refs.newNoteTextarea.focus();
      }
    },

    //Traigo todas notas existentes para este target.
    getTargetNotes(){
       targetsService.getTargetNotes(this.targetId)
      .then( res => {
        const { result } = res;
        this.listOfNotes = (result) ? res.result : [];

        //Reviso si existe alguna nota con estado cerrado
        if(this.listOfNotes.length > 0){

          const maxIdObject = this.listOfNotes.reduce((max, obj) => {
              return parseInt(obj.id) > parseInt(max.id) ? obj : max;
          }, this.listOfNotes[0]);

          const targetNoteStatusId = maxIdObject.target_note_status_id;

          this.targetNoteStatus = targetNoteStatusId
        }
      })
      .catch(err => console.log(err))
    },

    createTargetNote(){
      this.savingData = true;

      //Si editNoteId tiene un valor, entonces estoy editando un note
      if(this.editNoteId) {
        const targetNoteId = this.editNoteId
        targetsService.editTargetNote(this.targetId, targetNoteId, this.message)
         .then( res => {
            this.listOfNotes.find( el => el.id == this.editNoteId).message = this.message
            this.message = '';
            this.savingData = false;
            this.lastNoteModifyId = this.editNoteId
            this.editNoteId = null
        })
        .catch( err => console.log(err))
      } else {
        targetsService.createTargetNote(this.targetId, this.message)
         .then( res => {
            const { result } = res;
            if(result ){
              this.listOfNotes = res.result
            }
            this.message = '';
            this.savingData = false;
        })
        .catch( err => console.log(err))
      }
    },

    changeTargetNoteStatus(){
      targetsService.changeTargetNoteStatus(this.targetId, this.targetNoteStatus)
         .then( res => {
            const { result } = res;
        })
        .catch( err => console.log(err))
    },

    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
  },
};
</script>
